// extracted by mini-css-extract-plugin
export default {"listItem":"Ecommerce_listItem__y27Ky"};